import NextImage from 'next/future/image'

export default function ComponentBlocksSingleImage ({ Image }) {
  return (
    <div className="col-12">
      <NextImage
        alt=""
        src={`${process.env.NEXT_PUBLIC_CMS_URL}${Image.data.attributes.url}`}
        width={Image.data.attributes.width}
        height={Image.data.attributes.height}
        className="img-fluid w-100"
      />
    </div>
  )
}
